<template>
  <v-card class="props">
    <v-card-title>
      {{ title }}
    </v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid">
        <v-file-input
          accept="image/*"
          label="Обложка"
          hint="726×404"
          persistent-hint
          @change="handleImage"
        />
        <img
          class="cover"
          v-if="newData.cover"
          width="100%"
          :src="newData.cover"
          alt="Обложка"
        />
        <v-tabs v-model="tab" fixed-tabs>
          <v-tabs-slider />
          <v-tab>Русский</v-tab>
          <v-tab>Казахский</v-tab>
          <v-tab>Английский</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item eager v-for="(caption, def) in langs" :key="def">
            <v-textarea
              v-model="newData['lead_' + def]"
              :label="`Краткое описание (${caption})`"
              :rules="rules.lead"
              hint="2-3 предложения"
            />
            <v-text-field
              v-model="newData['title_' + def]"
              :label="`Заголовок (${caption})`"
              :rules="rules.title"
            />
            <v-card-actions>
              <v-btn text color="indigo" @click="content(def)">
                Сохранить и открыть контент
              </v-btn>
            </v-card-actions>
          </v-tab-item>
        </v-tabs-items>

        <v-switch
          v-model="newData.show"
          label="Показывать на сайте"
          color="success"
        ></v-switch>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn text color="light-green darken-4" @click="save"> Сохранить </v-btn>
    </v-card-actions>
    <snackbar v-bind.sync="snackbar" />
  </v-card>
</template>

<script>
import Snackbar from "../Snackbar";
import transport from "../../mixins/transport";
import { VueEditor } from "vue2-editor";
import readBase64 from "../../mixins/readBase64";

export default {
  name: "NewsProps",
  components: { Snackbar, VueEditor },
  mixins: [transport, readBase64],
  props: {
    data: {
      type: Object,
      required: true,
      show: Boolean,
      title_ru: String,
      title_kk: String,
      title_en: String,
      cover: String,
      tn: String
    }
  },
  data() {
    return {
      newData: {},
      tab: 0,
      rules: {
        title:[
          (v) => !!v || "Заполните поле",
          (v) => !v || v.length < 255 || "не более 255 символов"
        ],
        lead:[
          (v) => !v || v.length < 65535 || "не более 65535 символов"
        ]
      },
      valid: true,
      langs: {
        ru: "рус",
        kk: "каз",
        en: "eng"
      }
    };
  },
  computed: {
    title() {
      return this.data.id
        ? `Редактирование: «${this.data.title_ru}»`
        : "Новая статья";
    }
  },
  watch: {
    data: {
      immediate: true,
      handler() {
        this.newData = Object.assign({}, this.data);
      }
    }
  },
  methods: {
    handleImage(file) {
      this.readBase64(file).then((stringData) => {
        this.$set(this.newData, "cover", stringData);
      });
    },
    save() {
      this.$refs.form.validate();
      if (!this.valid) return;
      this.$emit("update", this.newData);
    },
    content(lang) {
      this.$refs.form.validate();
      if (!this.valid) return;
      this.$emit("content", this.newData, lang);
    }
  }
};
</script>
<style lang="scss">
.collectionProps {
  .v-card__actions {
    flex-direction: column;
    align-items: flex-end;
  }
}
</style>
